var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import EventBus from '@EventBus';
import { BUNDLE } from '@/stores/defs';
import { mapGetters } from 'vuex';
import { isEmpty } from 'lodash';
var mixinName = {
    computed: __assign({}, mapGetters({
        getBundle: BUNDLE.GET_BUNDLE,
    })),
    methods: {
        displayQuickAdd: function () {
            var notBundleFunc = this.notBundle;
            var notBundle = true;
            if (typeof notBundleFunc === 'function') {
                notBundle = notBundleFunc();
            }
            var noOptions = this._noOptions;
            return noOptions && notBundle;
        },
        increment: function () {
            this.itemQuantity++;
            this.itemQuantity = Math.min(100, this.itemQuantity);
        },
        decrement: function () {
            this.itemQuantity--;
            this.itemQuantity = Math.max(1, this.itemQuantity);
        },
        setQuantityFromInput: function (value) {
            this.itemQuantity = value;
        },
        handleClickQuickAdd: function () {
            var addIcon = this.$refs['quickAdd'].firstElementChild;
            var vue = this;
            this.$anime.timeline({
                easing: 'easeInOutQuad',
            }).add({
                targets: addIcon,
                translateY: [
                    {
                        value: '-8em',
                        duration: 333,
                    },
                    {
                        value: '16em',
                        duration: 0,
                    },
                    {
                        value: '0em',
                        duration: 333,
                    }
                ],
                opacity: [
                    {
                        value: 0,
                        duration: 100,
                    },
                    {
                        value: 1,
                        duration: 333,
                        delay: 233,
                    },
                ]
            }).finished.then(function () {
                if (!isEmpty(vue.getBundle)) {
                    EventBus.$emit("quick-add-bundle-" + vue.item.id);
                }
                else {
                    vue._addItemToCart(vue.item, vue.itemQuantity);
                }
            });
        },
    },
};
export default mixinName;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/menuItemQuickAddMixin.ts
// module id = c/bo
// module chunks = 18